import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from '../../constants/api-constants';
import { catchError, map, Observable, throwError } from 'rxjs';
import { PaginationModel, ProductModel, RequestParamModel } from "@coreModels";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient) {
  }

  /**
   * This method is used to get settings
   * @returns
   */
  getSettings(requestParamModel: RequestParamModel): any {
    return this.http.get(ApiConstants.SETTINGS_URL + requestParamModel.getParams())
      .pipe(map((response: any) => {
        return response.body.data as any;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }

  /**
   * This method is used to get setting details
   */
  getSettingViewDetail(): Observable<any> {
    return this.http.get(ApiConstants.SETTING_DETAIL_URL)
      .pipe(map((response: any) => {
        return response.data as any;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }


  /**
   * This method is used to download eligibility criteria pdf
   * @returns
   */
  getDownloadEligibilityCriteria(): any {
    return this.http.get(ApiConstants.SETTING_DOWNLOAD_ELIGIBILITY_CRITERIA_URL)
      .pipe(map((response: any) => {
        return response.data || response.body.data;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }
}
